<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'change-permission'"
    @hidden="$emit('onCloseModal')"
  >
    <template #modal-header>
      <div class="head-label">แก้ไขสิทธิ์การเข้าใช้งานเกม</div>
    </template>

    <b-col cols="12">
      <b-row>
        <b-col cols="12">
          <setting-permission
            :formData="permissionForm"
            :tagOption="tagOption"
            :value="TAG_ADD"
            @onInputSelectTag="selectedTagPer"
            @onInputDuplicateTag="checkDuplicateTag"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <div class="privilege-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                :loading="loading"
                :type="'submit'"
                class="ml-1"
                :btnLabel="'Apply'"
                @click.native="onSubmitModal"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import SettingPermission from "./SettingPermission.vue";
import useChangePermission from "../../hooks/useChangePermission";

export default {
  components: { BaseModal, SettingPermission },
  props: {
    tagOption: { type: Object, default: {} },
  },
  setup(props) {
    const {
      permissionForm,
      loading,
      TAG_ADD,
      onSubmitModal,
      selectedTagPer,
      checkDuplicateTag,
    } = useChangePermission(props);

    return {
      permissionForm,
      loading,
      TAG_ADD,
      onSubmitModal,
      selectedTagPer,
      checkDuplicateTag,
    };
  },
};
</script>


<style scoped>
@import "~@/assets/css/pages/quiz/privilege.css";
@import "~@/assets/css/override-styles/tag-dropdown.css";
</style>>


